import { InviteAppState } from '../models';

export const defaultInvite: InviteAppState = {
  isInviteAppOpen: false,
};
